module.exports = __webpack_public_path__ + "img/qr-code-checkin-sample.8bdd1006.png";